var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 76,
    viewBox: "0 0 67 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7543 0.217143C50.4991 0.217143 56.3619 1.99047 60.3429 5.53714C64.3238 9.01143 66.3143 13.5714 66.3143 19.2171C66.3143 20.5924 66.2057 22.0038 65.9886 23.4514C65.12 28.3733 62.8762 32.861 59.2571 36.9143C55.7105 40.8952 50.9333 43.6819 44.9257 45.2743L57.6286 76H39.9314L28.64 46.4686H21.3657L16.1543 76H0.845714L14.3086 0.217143H42.7543ZM50.3543 23.7771C50.499 22.4743 50.5714 21.6057 50.5714 21.1714C50.5714 18.421 49.7029 16.2857 47.9657 14.7657C46.2286 13.2457 43.5867 12.4857 40.04 12.4857H27.3371L23.32 35.1771H36.0229C40.0762 35.1771 43.2971 34.1638 45.6857 32.1371C48.1467 30.1105 49.7029 27.3238 50.3543 23.7771Z",
    fill: "#FA530A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.8f673ecd5fb4c1447d7818cbf3a411fc.svg";
export { ForwardRef as ReactComponent };